'use strict';

angular.module('study.export', [
    'export',
    'gettext',
    'route',
]);
